import React from "react";
import { useNavigate } from "react-router-dom";

const DashboardEmpleado = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        overflow: "hidden", // elimina scroll
        display: "flex",
        background: "#FFF5FA",
      }}
    >
      {/* LADO IZQUIERDO */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "80px",
        }}
      >
        <h2
          style={{
            fontSize: "40px",
            fontWeight: "700",
            color: "#333",
            marginBottom: "20px",
          }}
        >
           Gestiona tu perfil laboral fácilmente
        </h2>

        <p style={{ fontSize: "18px", color: "#666", marginBottom: "40px" }}>
          Mantén tu información actualizada, explora nuevas oportunidades dentro de la empresa y postúlate a nuevos retos.
        </p>


        <div style={{ display: "flex", gap: "20px" }}>
          <button
            onClick={() => navigate("/session/offer/offers")}
            style={{
              padding: "12px 30px",
              backgroundColor: "#C2185B",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Ver Ofertas
          </button>

          <button
            onClick={() => navigate("/session/curriculum/mycurriculum")}
            style={{
              padding: "12px 30px",
              backgroundColor: "transparent",
              color: "#C2185B",
              border: "2px solid #C2185B",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Mi Hoja de Vida
          </button>
        </div>
      </div>

      {/* LADO DERECHO (IMAGEN SIN MARGEN) */}
      <div
        style={{
          flex: 1,
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <img
          src="/images/Dashboard.png"
          alt="Proceso laboral"
          style={{
            height: "100%",
            width: "auto",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  );
};

export default DashboardEmpleado;